<div class="parent" *ngIf="data?.length">
    <div class="grid">
      <span class="columnHeader" *ngFor="let t of columns">
        {{ t }}
      </span>
    </div>
    <div class="grid gridRow" *ngFor="let k of data">

      <span class="pertinent">{{ k.weapon?.primaryWeapon?.weapon_Category }}</span>
      <span class="">{{ k.weapon?.secondaryWeapon }}</span>

    </div>

</div>
<div class="recordCount" *ngIf="data?.length; else noData">
    {{ data.length }} weapon record(s)
</div>
<ng-template #noData>
  <div class="recordCount">We don't have any Weapons for this record.</div>
</ng-template>
